import { FC, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

import FullScreenLoader from '@components/loader/FullScreenLoader';
import { useAuth } from '@hooks/useAuth';
import { authSlice } from '@redux/state/authSlice';
import { useAppDispatch } from '@redux/store';

import { getRedirectPath } from './routingHelpers';
import { RouteGuardProps } from './types';

export const RouteGuard: FC<RouteGuardProps> = ({
  children,
  accessLevel,
  fallbackPath,
}) => {
  const auth = useAuth();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const redirectResult = getRedirectPath(
    auth,
    accessLevel,
    location,
    fallbackPath,
  );

  useEffect(() => {
    if (redirectResult.autoGuest && auth.isAuthReady) {
      dispatch(authSlice.actions.setUser(null));
    }
  }, [redirectResult.autoGuest, auth.isAuthReady, dispatch]);

  if (!auth.isAuthReady) {
    return <FullScreenLoader isLoading />;
  }

  if (redirectResult.path) {
    return (
      <Navigate to={redirectResult.path} state={redirectResult.state} replace />
    );
  }

  return <>{children}</>;
};
